import { useEffect } from 'react';
import { useAuthStore } from '@/stores/auth-store';
import { api } from '@/lib/api';
import type { ApiResponse, User, Organization } from '@sparqplug/types';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { setUser, setOrganization, setAccessToken, setLoading, signOut } = useAuthStore();

  useEffect(() => {
    let active = true;
    async function restoreSession() {
      const token = window.sessionStorage.getItem('sparqplug_access_token');
      if (!token) {
        signOut();
        setLoading(false);
        return;
      }

      setAccessToken(token);
      try {
        const response = await api.get<ApiResponse<{ user: User; organization: Organization }>>('/auth/me');
        if (!active) return;
        if (response.success && response.data) {
          setUser(response.data.user);
          setOrganization(response.data.organization);
        } else signOut();
      } catch {
        if (active) signOut();
      } finally {
        if (active) setLoading(false);
      }
    }
    void restoreSession();
    return () => { active = false; };
  }, [setAccessToken, setLoading, setOrganization, setUser, signOut]);

  return <>{children}</>;
}
